import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, of, switchMap } from 'rxjs';

import { API_CONFIG } from '../config';
import { Auth } from '../services/auth';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  if (!isApiRequest(request.url) || request.headers.has('Authorization')) {
    return next(request);
  }

  const auth = inject(Auth);

  return from(auth.getAccessToken()).pipe(
    // Only fall back to the original request when token acquisition itself fails.
    // API errors from `next(...)` must propagate unchanged so form-level handlers
    // can surface 4xx business errors without triggering an unauthenticated retry.
    catchError(() => of(null)),
    switchMap((token) => {
      if (!token) {
        return next(request);
      }

      return next(
        request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        }),
      );
    }),
  );
};

function isApiRequest(url: string) {
  try {
    const base = typeof window === 'undefined' ? 'http://localhost' : window.location.origin;
    const resolvedUrl = new URL(url, base);
    return resolvedUrl.pathname === API_CONFIG.basePath || resolvedUrl.pathname.startsWith(`${API_CONFIG.basePath}/`);
  } catch {
    return false;
  }
}
